export enum ContactTimeHours {    
    NineAm = 9,
    TenAm = 10,
    ElevenAm = 11,
    Noon = 12,
    OnePm = 13,
    TwoPm = 14,
    ThreePm = 15,
    FourPm = 16,
    FivePm = 17
}